/*
 * @Description:
 * @Author: rqcheng
 * @Date: 2022-06-09 12:45:36
 * @LastEditors: rqcheng
 * @LastEditTime: 2025-06-20 17:01:41
 */
import { removeAccessToken } from "@/plugins/auth";
import { resetRouter } from "@/router";
import * as types from "./mutationsType";
import { getSwitchRegion, getProfile, login, logout } from "@/api/http";
export default {
  async login({ commit }, params) {
    const { data } = await login(params);
    const token = data.token || "accessToken";
    commit(types.ACCESS_TOKEN, token);
  },
  async logout({ commit }) {
    await logout();
    removeAccessToken();
    commit(types.ACCESS_TOKEN, "");
    resetRouter();
  },
  async getUserInfo({ commit }) {
    const { data } = await getProfile();
    commit("USER_PROFILE", data);
  },
  setMenuOptions({ commit }, options) {
    commit(types.OPTIONS_EDIT, options);
  },
  setArticleTitle({ commit }, article) {
    commit(types.ARTICLE_TITLE_EDIT, article);
  },
  setCurrentRegion({ commit }) {
    getSwitchRegion().then(
      res => {
        commit(types.CURRENT_REGION, res.data);
      },
      err => {
        commit(types.CURRENT_REGION, {});
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js